import React from 'react';
import { cn } from '@/lib/utils';

type LegalListProps = {
  items: React.ReactNode[];
  ordered?: boolean;
  className?: string;
};

export function LegalList({ items, ordered = false, className }: LegalListProps) {
  const Tag = ordered ? 'ol' : 'ul';

  return (
    <Tag
      className={cn(
        'pl-5 space-y-1 text-gray-600',
        ordered ? 'list-decimal' : 'list-disc',
        className
      )}
    >
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </Tag>
  );
}
